export default __webpack_public_path__ + "static/media/agenda.0443e008.png";